import { defineMessages } from 'react-intl';

const messages: {
	addOverride: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	addParticipants: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cancel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirm: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirmProceed: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	delete: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	deletedEscalation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	deletedSchedule: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	discard: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	duplicate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	edit: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	end: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	endDate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	endEarlierStart: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	endTime: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	error: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	escalation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	formerUser: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	maxLength: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	maxValue: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	minValue: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	nameSpaceValidationError: {
		defaultMessage: string;
		description: string;
		id: string;
	} /*
    Misc common messages
    */;
	noOne: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noSpaceAtEndOrStart: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	overrideButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	participants: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	quickOverrideTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	remove: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	replaceWith: {
		defaultMessage: string;
		description: string;
		id: string;
	} /*
    Common validation related messages
    */;
	required: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	saveButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	schedule: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	search: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	select: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	selectionCount: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	start: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	startDate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	startEndSame: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	startLaterEnd: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	startTime: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	team: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	teamDeleted: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thirtyMinuteInterval: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	timePast: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tryAgain: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	turnOff: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	turnOn: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	/*
   Misc common messages
  */

	noOne: {
		id: 'eoc-schedule.common.no-one',
		defaultMessage: 'No one',
		description:
			'Text displayed as a placeholder when no user is assigned to an on-call shift in the schedule.',
	},
	error: {
		id: 'eoc-schedule.common.error',
		defaultMessage: 'Error',
		description:
			'Heading shown in an error state panel when an operation fails in the schedule component.',
	},
	tryAgain: {
		id: 'eoc-schedule.common.try-again',
		defaultMessage: 'Try again',
		description:
			'Label on a button that allows the user to retry a failed action in the schedule component.',
	},
	cancel: {
		id: 'eoc-schedule.common.cancel',
		defaultMessage: 'Cancel',
		description:
			'Label on a button that dismisses a modal or dialog without saving changes in the schedule component.',
	},
	confirm: {
		id: 'eoc-schedule.common.confirm',
		defaultMessage: 'Confirm',
		description: 'Label on a button that confirms and submits an action in the schedule component.',
	},
	addOverride: {
		id: 'eoc-schedule.common.add-override',
		defaultMessage: 'Add override',
		description:
			'Label on a button or menu item that opens the add override dialog for a schedule shift period.',
	},
	overrideButton: {
		id: 'eoc-schedule.common.override',
		defaultMessage: 'Override',
		description: 'Label on a button that initiates an override action on a schedule shift.',
	},
	saveButton: {
		id: 'eoc-schedule.common.save',
		defaultMessage: 'Save',
		description:
			'Label on a button that saves changes made to a schedule or rotation configuration.',
	},
	edit: {
		id: 'eoc-schedule.common.edit',
		defaultMessage: 'Edit',
		description: 'Label on a button that opens the edit view for an on-call schedule.',
	},
	turnOff: {
		id: 'eoc-schedule.common.turn-off',
		defaultMessage: 'Turn off',
		description:
			'Label on a button that deactivates an on-call schedule so it stops producing shifts.',
	},
	turnOn: {
		id: 'eoc-schedule.common.turn-on',
		defaultMessage: 'Turn on',
		description: 'Label on a button that reactivates a previously disabled on-call schedule.',
	},
	delete: {
		id: 'eoc-schedule.common.delete',
		defaultMessage: 'Delete',
		description: 'Button for deleting schedule or rotation.',
	},
	duplicate: {
		id: 'eoc-schedule.common.duplicate',
		defaultMessage: 'Duplicate',
		description: 'Button for duplicating schedule or rotation.',
	},
	remove: {
		id: 'eoc-schedule.common.remove',
		defaultMessage: 'Remove',
		description:
			'Label on a button that removes a participant from a rotation in the schedule editor.',
	},
	start: {
		id: 'eoc-schedule.common.start',
		defaultMessage: 'Start',
		description:
			'Label for the field showing the start date and time of an on-call shift or override.',
	},
	end: {
		id: 'eoc-schedule.common.end',
		defaultMessage: 'End',
		description:
			'Label for the field showing the end date and time of an on-call shift or override.',
	},
	startTime: {
		id: 'eoc-schedule.common.start-time',
		defaultMessage: 'Start time',
		description:
			'Label for the time picker field indicating when an on-call shift or override begins.',
	},
	endTime: {
		id: 'eoc-schedule.common.end-time',
		defaultMessage: 'End time',
		description:
			'Label for the time picker field indicating when an on-call shift or override ends.',
	},
	startDate: {
		id: 'eoc-schedule.common.start-date',
		defaultMessage: 'Start date',
		description:
			'Label for the date picker field indicating when an on-call shift or override begins.',
	},
	endDate: {
		id: 'eoc-schedule.common.end-date',
		defaultMessage: 'End date',
		description:
			'Label for the date picker field indicating when an on-call shift or override ends.',
	},
	team: {
		id: 'eoc-schedule.common.team',
		defaultMessage: 'Team',
		description: 'Label that indicates responder is of type: Team',
	},
	escalation: {
		id: 'eoc-schedule.common.escalation',
		defaultMessage: 'Escalation',
		description: 'Label that indicates responder is of type: Escalation',
	},
	schedule: {
		id: 'eoc-schedule.common.schedule',
		defaultMessage: 'Schedule',
		description: 'Label that indicates responder is of type: Schedule',
	},
	selectionCount: {
		id: 'eoc-schedule.common.selection-count',
		defaultMessage: '{count} shifts selected',
		description: 'Indicates how many shifts are selected for override.',
	},
	quickOverrideTitle: {
		id: 'eoc-schedule.common.quick-override-title',
		defaultMessage: 'Override',
		description:
			'Heading shown on the quick override shift card that allows a user to temporarily replace an on-call assignee.',
	},
	search: {
		id: 'eoc-schedule.common.search',
		defaultMessage: 'Search',
		description: 'Label of search icon that shown inside search participant field',
	},
	replaceWith: {
		id: 'eoc-schedule.common.replace-with',
		defaultMessage: 'Replace with',
		description: 'A button for opening popup for replacing a participant.',
	},
	participants: {
		id: 'eoc-schedule.common.participants',
		defaultMessage: 'Participants',
		description:
			'Section label shown above the list of users participating in an on-call rotation.',
	},
	addParticipants: {
		id: 'eoc-schedule.common.add-participants',
		defaultMessage: 'Add people, teams, and escalation policies',
		description: 'Placeholder text for auto complete field for participants (responders).',
	},
	select: {
		id: 'eoc-schedule.common.select',
		defaultMessage: 'Select',
		description:
			'Label on a button or dropdown option that triggers a selection action in the schedule component.',
	},
	teamDeleted: {
		id: 'eoc-schedule.common.team-deleted',
		defaultMessage: 'Team deleted',
		description: 'Fallback responder name that suggest team is deleted.',
	},
	deletedSchedule: {
		id: 'eoc-schedule.common.deleted-schedule',
		defaultMessage: 'Deleted schedule',
		description: 'Fallback responder name that suggest schedule is deleted.',
	},
	deletedEscalation: {
		id: 'eoc-schedule.common.deleted-escalation',
		defaultMessage: 'Deleted escalation',
		description: 'Fallback responder name that suggest escalation is deleted.',
	},
	formerUser: {
		id: 'eoc-schedule.common.former-user',
		defaultMessage: 'Former user',
		description: 'Fallback responder name that suggest user is deactivated or deleted.',
	},
	discard: {
		id: 'eoc-schedule.common.discard',
		defaultMessage: 'Discard',
		description:
			'Label on a button that discards unsaved changes to a schedule or rotation and reverts to the last saved state.',
	},
	confirmProceed: {
		id: 'eoc-schedule.common.confirm-proceed',
		defaultMessage: 'Are you sure to proceed?',
		description:
			'Text shown in a confirmation dialog asking the user to verify they want to continue with a potentially destructive action.',
	},

	/*
   Common validation related messages
  */

	required: {
		id: 'eoc-schedule.common.required',
		defaultMessage: 'This field is required.',
		description: 'A text that informs users that field should be filled.',
	},
	noSpaceAtEndOrStart: {
		id: 'eoc-schedule.common.no-space-at-end-or-start',
		defaultMessage: 'Field cannot contain spaces at start or end.',
		description: 'A text that informs users that field cannot start or end with spaces.',
	},
	maxLength: {
		id: 'eoc-schedule.common.max-length',
		defaultMessage: 'Field cannot be longer than {max} characters.',
		description: 'A text that informs users that field should be shorter than certain length.',
	},
	maxValue: {
		id: 'eoc-schedule.common.max-value',
		defaultMessage: 'Field should be less than {max}.',
		description: 'A text that informs users that field should be less than certain value.',
	},
	minValue: {
		id: 'eoc-schedule.common.min-value',
		defaultMessage: 'Enter digit 1 or more.',
		description:
			'This sentence instructs the user to input a numeric value of at least 1 digit or greater.',
	},
	timePast: {
		id: 'eoc-schedule.common.time-past',
		defaultMessage: 'Time should be later than current time.',
		description: 'Validation error that indicates time values is in past.',
	},
	startLaterEnd: {
		id: 'eoc-schedule.common.start-later-end',
		defaultMessage: 'Start time should be before the end time.',
		description: 'Validation error that indicates start time is later than the end time.',
	},
	endEarlierStart: {
		id: 'eoc-schedule.common.end-earlier-start',
		defaultMessage: 'End time should be after the start time.',
		description: 'Validation error that indicates end time is earlier than the start time.',
	},
	startEndSame: {
		id: 'eoc-schedule.common.start-end-same',
		defaultMessage: 'Start and end time cannot be same.',
		description: 'Validation error that indicates start and end time should be different.',
	},
	thirtyMinuteInterval: {
		id: 'eoc-schedule.common.thirty-minute-intervals',
		defaultMessage: 'Time should be defined as 30 minute intervals.',
		description: 'Validation error that indicates time can be in 30 minutes intervals.',
	},
	nameSpaceValidationError: {
		id: 'eoc-schedule.common.name-space-validation-error',
		defaultMessage: 'The name cannot start or end with a space.',
		description: 'Error message for name validation when it starts or ends with a space',
	},
});

export { messages };
